import * as jsforce from 'jsforce'

// 環境変数（Vite）
const SALESFORCE_CLIENT_ID = import.meta.env.VITE_SALESFORCE_CLIENT_ID
const SALESFORCE_REDIRECT_URI = import.meta.env.VITE_SALESFORCE_REDIRECT_URI
const SALESFORCE_LOGIN_URL = import.meta.env.VITE_SALESFORCE_LOGIN_URL || 'https://login.salesforce.com'
const SALESFORCE_PROXY_URL = import.meta.env.VITE_SALESFORCE_PROXY_URL

// OAuth認証開始 (User-Agent Flow / Implicit Grant)
export function startOAuthFlow() {
  // User-Agent Flow: 手動でURLを構築
  const params = new URLSearchParams({
    response_type: 'token',
    client_id: SALESFORCE_CLIENT_ID,
    redirect_uri: SALESFORCE_REDIRECT_URI,
    scope: 'api',
  })

  const authUrl = `${SALESFORCE_LOGIN_URL}/services/oauth2/authorize?${params.toString()}`

  window.location.href = authUrl
}

// OAuth コールバック処理 (User-Agent Flow)
export async function handleOAuthCallback(): Promise<jsforce.Connection> {
  // User-Agent Flowではトークンがフラグメント(#)に含まれる
  const hash = window.location.hash.substring(1)
  const params = new URLSearchParams(hash)

  console.log('URL hash:', window.location.hash)
  console.log('Parsed params:', Object.fromEntries(params))

  const accessToken = params.get('access_token')
  const instanceUrl = params.get('instance_url')

  if (!accessToken || !instanceUrl) {
    console.error('Missing tokens. Full URL:', window.location.href)
    throw new Error('Access token or instance URL not found')
  }

  // Access Token と Instance URL をローカルストレージに保存
  localStorage.setItem('sf_access_token', accessToken)
  localStorage.setItem('sf_instance_url', instanceUrl)

  const conn = new jsforce.Connection({
    accessToken,
    instanceUrl,
    proxyUrl: SALESFORCE_PROXY_URL,
  })

  return conn
}

// 保存済みの認証情報から接続を復元
export function getConnection(): jsforce.Connection | null {
  const accessToken = localStorage.getItem('sf_access_token')
  const instanceUrl = localStorage.getItem('sf_instance_url')

  if (!accessToken || !instanceUrl) {
    return null
  }

  return new jsforce.Connection({
    accessToken,
    instanceUrl,
    proxyUrl: SALESFORCE_PROXY_URL,
  })
}

// 現在のユーザー情報を取得
export async function getCurrentUser(conn: jsforce.Connection): Promise<{
  id: string
  name: string
  email: string
  username: string
  firstName: string
  lastName: string
} | null> {
  try {
    const response = await conn.request<{
      id: string
      name: string
      email: string
      username: string
      firstName: string
      lastName: string
    }>('/services/apexrest/current-user/')

    return response
  } catch (error) {
    console.error('Failed to fetch current user:', error)
    return null
  }
}

// ログアウト (Salesforceセッションも破棄)
export function logout() {
  const instanceUrl = localStorage.getItem('sf_instance_url')

  // localStorageをクリア
  localStorage.removeItem('sf_access_token')
  localStorage.removeItem('sf_instance_url')

  // Salesforceのログアウトエンドポイントにリダイレクト
  // これによりSalesforce側のセッションも破棄され、メタデータキャッシュもクリアされる
  if (instanceUrl) {
    const logoutUrl = `${instanceUrl}/secur/logout.jsp`
    window.location.href = logoutUrl
  }
}
